import { propertyMeta, typeMeta, MetaTypesBase } from "@/autogen/common";
import { PurchasableStateMeta } from "./PurchasableStateMeta";

export const MembershipStaffMetaFields = {
  assignId: propertyMeta("assignId", false, true, false, MetaTypesBase.number),
  purchaseDate: propertyMeta("purchaseDate", false, false, false, MetaTypesBase.LocalDate),
  startDate: propertyMeta("startDate", false, false, false, MetaTypesBase.LocalDate),
  expirationDate: propertyMeta("expirationDate", false, false, false, MetaTypesBase.LocalDate),
  price: propertyMeta("price", false, true, false, MetaTypesBase.number),
  purchasableState: propertyMeta("purchasableState", false, true, false, PurchasableStateMeta),
  voidCloseId: propertyMeta("voidCloseId", false, false, false, MetaTypesBase.number),
  temp: propertyMeta("temp", false, true, false, MetaTypesBase.boolean),
  createdOn: propertyMeta("createdOn", false, false, false, MetaTypesBase.Date),
  createdBy: propertyMeta("createdBy", false, false, false, MetaTypesBase.string),
  updatedOn: propertyMeta("updatedOn", false, false, false, MetaTypesBase.Date),
  updatedBy: propertyMeta("updatedBy", false, false, false, MetaTypesBase.string),
  guestPrivileges: propertyMeta("guestPrivileges", false, true, false, MetaTypesBase.boolean),
  membershipTypeName: propertyMeta("membershipTypeName", false, false, false, MetaTypesBase.string),
  programName: propertyMeta("programName", false, false, false, MetaTypesBase.string),
};

export const MembershipStaffMeta = typeMeta("MembershipStaff", MembershipStaffMetaFields);
